import React from 'react';
import Lightbox from '@cratejoy/lightbox';

import {
	ImagesContainer,
	ThumbnailImgs,
	ThumbBtn,
} from './reviewImagesStyles';
import LazyLoadedImg from 'core/components/LazyLoadedImg';
import PropTypes from "prop-types";

const ReviewImages = ({ images }) => {
	const lightBoxProps = images.map(img => ({
		url: img.highResUrl
	}));
	return (
		<ImagesContainer>
			{images.length > 0 && (
				<Lightbox src={lightBoxProps}>
					{({ openByIndex }) => (
						<ThumbnailImgs>
							{images.map((image, index) => (
								<ThumbBtn key={image.id} onClick={openByIndex(index)}>
									<LazyLoadedImg
										src={image.lowResUrl}
										alt={image.altText || `Customer review photo ${index + 1}`}
										title={image.altText || `Customer review photo ${index + 1}`}
										width="100"
										height="100"
									/>
								</ThumbBtn>
							))}
						</ThumbnailImgs>
					)}
				</Lightbox>
			)}
		</ImagesContainer>
	);
};

ReviewImages.propTypes = {
	images: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		altText: PropTypes.string,
		rank: PropTypes.number.isRequired,
		lowResUrl: PropTypes.string.isRequired,
		highResUrl: PropTypes.string.isRequired,
	})),
};

ReviewImages.defaultProps = {
	images: [],
};

export default ReviewImages;
